import Navbar from '../components/Navbar';
import ChainOrbit from '../components/SupportedChains';
import CTAFooter from '../components/CTAFooter';

export default function ChainsPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main className="pt-20">
        <ChainOrbit />
      </main>
      <CTAFooter />
    </div>
  );
}
